const categorias = ["todas", "escola", "mantenedora"];

export const categoriasProcessos = {
  todas: "Todas",
  escola: "Escola",
  mantenedora: "Mantenedora",
};

export const normalizarBusca = (valor = "") =>
  String(valor ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export const categoriaValida = (valor) =>
  categorias.includes(valor) ? valor : "todas";

export function agruparInstituicoes(registros) {
  const grupos = new Map();

  registros.forEach((registro) => {
    // Somente a categoria devolvida pela API; legado sem classificação fica em Escolas.
    const categoria = registro.tipo_instituicao === "mantenedora" ? "mantenedora" : "escola";

    const nome = registro.escola_mantenedora || "Instituição não informada";

    const chave = JSON.stringify([
      categoria,
      registro.mantenedora_id ?? "",
      registro.instituicao_id ?? nome,
    ]);

    if (!grupos.has(chave)) {
      grupos.set(chave, {
        id: chave,
        name: nome,
        categoria,
        mantenedora: registro.mantenedora_nome || "",
        processos: [],
      });
    }

    const grupo = grupos.get(chave);

    if (
      !grupo.processos.some(
        (processo) => processo.process_id === registro.process_id,
      )
    ) {
      grupo.processos.push(registro);
    }
  });

  return [...grupos.values()].sort((a, b) =>
    a.name.localeCompare(b.name, "pt-BR"),
  );
}

export function responsavelInstituicao(instituicao) {
  const processos = instituicao.processos;

  const nomes = [
    ...new Set(
      processos.map((processo) => processo.nome_analista).filter(Boolean),
    ),
  ];

  const atribuido = processos.some(
    (processo) =>
      processo.id_analista != null || Boolean(processo.nome_analista),
  );

  const meu = processos.some(
    (processo) => processo.atribuido_ao_usuario_logado === true,
  );

  return {
    atribuido,
    meu,
    rotulo: meu
      ? "Atribuído a mim"
      : atribuido
        ? nomes.length
          ? `Atribuído a: ${nomes.join(", ")}`
          : "Atribuído a outro analista"
        : "Sem atribuição",
  };
}

export function filtrarInstituicoes(
  instituicoes,
  busca,
  categoria,
  atribuicao,
) {
  const termo = normalizarBusca(busca.trim());

  return instituicoes.filter((instituicao) => {
    const responsavel = responsavelInstituicao(instituicao);

    const correspondeAtribuicao =
      atribuicao === "unassigned"
        ? !responsavel.atribuido
        : atribuicao === "mine"
          ? responsavel.meu
          : atribuicao === "others"
            ? responsavel.atribuido && !responsavel.meu
            : true;

    return (
      (categoria === "todas" || categoria === instituicao.categoria) &&
      correspondeAtribuicao &&
      (!termo ||
        normalizarBusca(
          [
            instituicao.name,
            instituicao.mantenedora,
            ...instituicao.processos.flatMap((processo) => [
              processo.processo_nome,
              processo.modalidade,
              processo.nome_analista,
            ]),
          ].join(" "),
        ).includes(termo))
    );
  });
}

// Indicadores globais da lista de processos abertos, sem influência dos filtros.
export function calcularIndicadoresProcessos(registros) {
  const processos = new Map();

  for (const registro of registros) {
    if (registro.process_id != null) {
      const id = String(registro.process_id);

      if (!processos.has(id)) {
        processos.set(id, registro);
      }
    }
  }

  const escolas = new Set();
  const mantenedoras = new Set();

  let meus = 0;
  let semAtribuicao = 0;

  for (const processo of processos.values()) {
    if (processo.tipo_instituicao === "escola") {
      escolas.add(
        String(
          processo.instituicao_id ??
            processo.escola_mantenedora ??
            processo.process_id,
        ),
      );
    } else if (processo.tipo_instituicao === "mantenedora") {
      mantenedoras.add(
        String(
          processo.mantenedora_id ??
            processo.instituicao_id ??
            processo.escola_mantenedora ??
            processo.process_id,
        ),
      );
    }

    if (processo.atribuido_ao_usuario_logado === true) {
      meus += 1;
    }

    if (processo.id_analista == null) {
      semAtribuicao += 1;
    }
  }

  return {
    total: processos.size,
    escolas: escolas.size,
    mantenedoras: mantenedoras.size,
    meus,
    semAtribuicao,
  };
}
